import { useState } from 'react'
import { motion } from 'framer-motion'
import { Send, Download, Users, HeadphonesIcon, Plus } from 'lucide-react'
import { useStore, selectTotalBalance, selectRecentTransactions } from '@/store'
import BalanceDisplay from '@/components/BalanceDisplay'
import ActionButton from '@/components/ActionButton'
import TransactionItem from '@/components/TransactionItem'
import VirtualCard from '@/components/VirtualCard'
import Button from '@/components/ui/Button'
import { toast } from 'sonner'

export default function Dashboard() {
  const [selectedCardIndex, setSelectedCardIndex] = useState(0)
  
  const wallets = useStore(state => state.wallets)
  const cards = useStore(state => state.cards)
  const transactions = useStore(state => selectRecentTransactions(state, 5))
  const totalBalance = useStore(selectTotalBalance)
  
  const activeCards = cards.filter(c => c.status === 'active')
  const selectedCard = activeCards[selectedCardIndex]
  
  const handleSend = () => {
    toast.info('Send feature coming soon!')
  }
  
  const handleReceive = () => {
    toast.info('Receive feature coming soon!')
  }
  
  const handleRefer = () => {
    toast.info('Referral feature coming soon!')
  }
  
  const handleSupport = () => {
    toast.info('Support feature coming soon!')
  }
  
  return (
    <div className="space-y-6 pb-8">
      {/* Balance Display */}
      <BalanceDisplay 
        balance={totalBalance}
        change24h={3240.50}
        change24hPercent={1.55}
      />
      
      {/* Quick Actions */}
      <div className="grid grid-cols-4 gap-3">
        <ActionButton 
          icon={Send} 
          label="Send" 
          variant="primary"
          onClick={handleSend}
        />
        <ActionButton 
          icon={Download} 
          label="Receive" 
          onClick={handleReceive}
        />
        <ActionButton 
          icon={Users} 
          label="Refer" 
          onClick={handleRefer}
        />
        <ActionButton 
          icon={HeadphonesIcon} 
          label="Support" 
          onClick={handleSupport}
        />
      </div>
      
      {/* Cards Section */}
      <section>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">My Cards</h2>
          <Button variant="ghost" size="sm" className="text-brand">
            <Plus className="w-4 h-4 mr-1" />
            Add
          </Button>
        </div>
        
        {selectedCard && (
          <div className="space-y-4">
            <VirtualCard 
              card={selectedCard} 
              isActive={true}
            />
            
            {/* Card dots indicator */}
            {activeCards.length > 1 && (
              <div className="flex justify-center gap-2">
                {activeCards.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedCardIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-200 ${
                      index === selectedCardIndex 
                        ? 'w-6 bg-brand' 
                        : 'bg-border hover:bg-border-hover'
                    }`}
                  />
                ))}
              </div>
            )}
          </div>
        )}
      </section>
      
      {/* Recent Transactions */}
      <section>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">Recent Activity</h2>
          <Button variant="ghost" size="sm">
            View All
          </Button>
        </div>
        
        <div className="space-y-1">
          {transactions.map((transaction, index) => (
            <motion.div
              key={transaction.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.05 }}
            >
              <TransactionItem transaction={transaction} />
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  )
}